import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

import Carousel from "./Carousel";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Testimonial from "./Testimonial";
import Section3 from "./Section3";
// import Faqs from "./Faqs";
import Section4 from "./Section4";
import Section5 from "./Section5";
import CarouselM from "./CarouselM";
// import safety from "../img/product/safety.JPG";
import Modal from "./Modal";
import "@fortawesome/fontawesome-free/css/all.min.css"; // Ensure Font Awesome is imported

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Trigger the modal to open when the component mounts
    setIsModalOpen(true);
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="home">
      <Modal isOpen={isModalOpen} onClose={closeModal} />
      <Carousel />
      <CarouselM />
      <Section1 />
      <Section2 />
      <Section5 />
      <Section4 />
      <Testimonial />
      {/* <div className="safety">
        <img src={safety} alt="Safety" />
      </div> */}
      {/* <Faqs /> */}
      <Section3 />

      {/* WhatsApp Icon */}
      {/* <a
        href="https://wa.me/8320844583" // Replace with your WhatsApp number
        target="_blank"
        // rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <i className="fab fa-whatsapp"></i>
      </a> */}
      {/* WhatsApp Icon */}
        <div className="whatsapp-container">
        <Link to="/career" className="curved-text-link">
          <svg className="curved-text" width="220" height="150" viewBox="0 0 220 45">
            <defs>
              <path id="curve" d="M 50,90 A 90,90 0 0,1 170,90" />
            </defs>
            <text width="100%">
              <textPath href="#curve" startOffset="45%" textAnchor="middle">
                🚀 We are hiring!
              </textPath>
            </text>
          </svg>
        </Link>
      
        <a
          href="https://wa.me/918320844583"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-icon"
        >
          <i className="fab fa-whatsapp whats-app"></i>
        </a>
      
        <style jsx>{`
          .whatsapp-container {
            position: fixed;
            bottom: 10px;
            right: 1px;
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 999;
          }
      
          .curved-text-link {
            text-decoration: none;
            cursor: pointer;
            transition: transform 0.2s ease-in-out;
            display: inline-block;
          }
      
          .curved-text-link:hover {
            transform: scale(1.10);
          }
          .curved-text text {
            fill: #e97f23;
            font-size: 16px;
            font-weight: 650;
            pointer-events: none;
          }
      
          .whatsapp-icon {
            width: 60px;
            height: 60px;
            background-color: #25d366;
            color: #fff;
            border-radius: 50px;
            text-align: center;
            font-size: 30px;
            box-shadow: 2px 2px 3px #999;
          }
      
          .whats-app {
            margin-top: 16px;
          }
      
          @media screen and (max-width: 767px) {
            .whatsapp-container {
              bottom: 20px;
              right: 10px;
            }
      
            .whatsapp-icon {
              width: 40px;
              height: 40px;
              font-size: 22px;
            }
      
            .whats-app {
              margin-top: 10px;
            }
      
            .curved-text text {
              font-size: 14px;
            }
          }
        `}</style>
      </div>
      </div>
  );
}
